"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificateServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
class CertificateServiceLive {
    async getTransactionNumberWithoutCertificate(companyId, type) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/certificate/transactions-without-certificate/${type}`);
        return response.data;
    }
    async updateCertificateIssueStatus(companyId, type, status, config) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/certificate/update-certificate-status/${type}/${status}`, { type, config });
        return response.data;
    }
    async updateCertificateConfig(companyId, config, type) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/certificate/update-config`, {
            type,
            config,
        });
        return response.data;
    }
    async issueBulkCertificates(companyId, type) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/certificate/issue-certificate-bulk/${type}`, {});
        return response.data;
    }
    async generateCertificate(companyId, type, shareholderId, certificateId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/certificate/${certificateId}/shareholder/${shareholderId}/generate/${type}`);
        return response.data;
    }
    async getBulkCertificate(companyId, range) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/certificate/bulk-download`, range);
        return response.data;
    }
    async uploadCertificate(companyId, data) {
        const formData = new FormData();
        formData.append("id", data.id);
        formData.append("type", data.type);
        formData.append("file", data.file, data.file.name);
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/certificate/upload`, formData);
        return response.data;
    }
    async getSignedInvestorCertificateUrl(companyId, shareholderId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/certificate/signed-url/${shareholderId}`);
        return response.data;
    }
}
exports.CertificateServiceLive = CertificateServiceLive;
//# sourceMappingURL=CertificateServiceLive.js.map